import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { withFormsy } from "formsy-react"
import InputErrorMessage from "shared/InputErrorMessage"
import RadioButtonNumber from "./RadioButtonNumber"

const RadioButtonLabeledGroupInput = ({
  className = "",
  columnCount = 1,
  disabled = false,
  errorMessages = [],
  id = "",
  isPristine = true,
  onChange,
  options,
  questionUuid,
  radioInputClassName = "",
  value = null,
}) => (
  <>
    <div className={`${className} grid grid-cols-${columnCount}`}>
      {
        options.map((option) => {
          const { active: optionActive, label: optionLabel, value: optionValue } = option
          const name = `${questionUuid}-${optionLabel}`

          // The id passed to the radio button group input serves as a base
          // from which the individual radio button ids are built.
          // If no id is passed then fallback to using name.
          const radioButtonIdBase = id || name
          const radioButtonId = `${radioButtonIdBase}-${optionValue}-radio-button`

          return (
            <RadioButtonNumber
              key={optionValue}
              className={clsx("p-4", radioInputClassName, !optionActive && "text-gray-200")}
              disabled={disabled}
              id={radioButtonId}
              value={optionValue}
              label={optionLabel}
              name={name}
              checked={optionValue === value}
              onChange={onChange}
              questionUuid={questionUuid}
              title={optionActive ? undefined : `${optionLabel} is inactive`}
            />
          )
        })
      }
    </div>
    <InputErrorMessage isPristine={isPristine} errorMessages={errorMessages} />
  </>
)

RadioButtonLabeledGroupInput.propTypes = {
  className: types.string,
  columnCount: types.number,
  disabled: types.bool,
  errorMessages: types.arrayOf(types.string),
  id: types.string,
  isPristine: types.bool,
  onChange: types.func.isRequired,
  options: types.arrayOf(types.object).isRequired,
  questionUuid: types.string.isRequired,
  radioInputClassName: types.string,
  value: types.number,
}

export const FormsyRadioButtonLabeledGroupInput = withFormsy(({ setValue, ...rest }) => (
  <RadioButtonLabeledGroupInput
    onChange={setValue}
    {...rest}
  />
))

export default RadioButtonLabeledGroupInput
